module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "fm5"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“...Whenever any Form of Government becomes destructive... it is the Right of the People to alter or to abolish it, and to institute new Government...it is their Right, it is their Duty, to throw off such Government, and to provide new Guards for their future Security.”")])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('span', [_vm._v("—THOMAS JEFFERSON")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "4em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Declaration of Independence")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center2"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Our death is not an end if we can live on in our children and the younger generation. For they are us, our bodies are only wilted leaves on the tree of life.”")])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('span', [_vm._v("—ALBERT EINSTEIN")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Collected Papers of Albert Einstein © 1987")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2673c5af","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/whenever.vue
// module id = 78
// module chunks = 0